import { useFormContext } from 'react-hook-form';
import React, { useCallback, useEffect } from 'react';
import { Card } from '@sravni/react-design-system/lib/Card';
import {
    AgreementAdvertisingCheckbox,
    AgreementPersonalDataCheckbox,
    ServerErrorMessage,
} from '@sravni/react-silent-authentication-form';
import { Text } from '@sravni/react-design-system/lib/Typography';
import cn from 'classnames';
import { GiftBanner } from '../../GiftBanner';
import { FIELD_NAME } from '../../../constants';
import { ContentProps } from '../types';
import { ConsentsScreenTexts } from '../ConsentsScreen.texts';
import styles from './ConsentsScreen.module.scss';

export const ConsentsScreenContentMobile = (props: ContentProps) => {
    const {
        checkboxLabel,
        onChangeAgreementPersonalData,
        onChangeAgreementAdvertising,
        submitAttempt,
        onConsentsScreenOpen,
    } = props;
    const { formState, watch, trigger } = useFormContext();
    const { errors } = formState;
    const [agreementPersonalData, agreementAdvertising] = watch([
        FIELD_NAME.AGREEMENT_PERSONAL_DATA,
        FIELD_NAME.AGREEMENT_ADVERTISING,
    ]);

    const isShowAdvertisingError = submitAttempt > 0 && !agreementAdvertising;

    const personalDataError = errors[FIELD_NAME.AGREEMENT_PERSONAL_DATA];

    const onChangePersonalData: React.ChangeEventHandler<HTMLInputElement> = useCallback(
        (event) => {
            trigger(FIELD_NAME.AGREEMENT_PERSONAL_DATA);
            onChangeAgreementPersonalData?.(event);
        },
        [onChangeAgreementPersonalData, trigger],
    );

    useEffect(() => {
        onConsentsScreenOpen?.({ agreementPersonalData, agreementAdvertising });
    }, []);

    const isShowPersonalDataError = personalDataError?.message || !agreementPersonalData;

    return (
        <Card size={16} color="dark" className={styles.content}>
            <Card
                size={16}
                color="light"
                className={cn({
                    [styles.advertisingCheckBoxError]: isShowAdvertisingError,
                })}>
                <AgreementAdvertisingCheckbox
                    className={styles.agreementAdvertisingCheckbox}
                    onChange={onChangeAgreementAdvertising}>
                    {checkboxLabel}
                </AgreementAdvertisingCheckbox>
            </Card>
            <GiftBanner className={cn('h-mt-8', styles.giftBanner)}>
                <AgreementPersonalDataCheckbox
                    className={styles.agreementCheckbox}
                    onChange={onChangePersonalData}
                    asListItem
                />
                <Text size={12} className={cn(styles.error, { [styles.hiddenError]: !isShowPersonalDataError })}>
                    {personalDataError?.message || ConsentsScreenTexts.PersonalDataErrorMessage}
                </Text>
            </GiftBanner>
            <ServerErrorMessage className="h-mt-12" />
        </Card>
    );
};
